import React, { useContext, useEffect } from 'react';
import { arrayOf, func, shape } from 'prop-types';
import { Route, Routes } from 'react-router-dom';
import * as R from 'ramda';

import { SubscriptionsContext } from 'feature/subscription-plans/SubscriptionsContext';
import PlanSelection from 'feature/subscription-plans/plan-selection/PlanSelection.connector';
import Enrollment from 'feature/subscription-plans/enrollment/Enrollment.connector';
import CustomerSelection from 'feature/subscription-plans/customer-selection/CustomerSelectionConnector';
import Confirmation from 'feature/subscription-plans/confirmation/Confirmation.connector';
import PermissionsRolesGuard from './PermissionsRolesGuard';

const Subscriptions = props => {
  const { globalCustomers, resetSubscriptions } = props;

  const { data } = useContext(SubscriptionsContext);

  useEffect(() => {
    return () => resetSubscriptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Routes>
      <Route element={<Enrollment />} index />
      <Route
        element={
          <PermissionsRolesGuard authCondition={!R.isEmpty(globalCustomers)} redirect="..">
            <CustomerSelection />
          </PermissionsRolesGuard>
        }
        path="step1"
      />
      <Route
        element={
          <PermissionsRolesGuard authCondition={!R.isNil(data.globalCustomer)} redirect="..">
            <PlanSelection />
          </PermissionsRolesGuard>
        }
        path="step2"
      />
      <Route
        element={
          <PermissionsRolesGuard
            authCondition={!R.isEmpty(data.planSelected.contractID)}
            redirect=".."
          >
            <Confirmation />
          </PermissionsRolesGuard>
        }
        path="step3"
      />
    </Routes>
  );
};

Subscriptions.propTypes = {
  globalCustomers: arrayOf(shape({})).isRequired,
  resetSubscriptions: func.isRequired,
};

export default Subscriptions;
